import { useFormikContext } from "formik";
import { Button } from "../../common/Button";
import React from "react";
import PropTypes from "prop-types";

export const ActionBtnsLoader = () => {
  return (
    <React.Fragment>
      <Button size="large" ghost={true} />
      <Button size="large" ghost={true} />
    </React.Fragment>
  );
};

export const BackBtn = ({ backBtnProps: { step, t, prevStep } }) => {
  return (
    <Button
      text={step > 0 ? t("back") : t("cancel")}
      bold={true}
      size="large"
      onClick={prevStep}
    />
  );
};
BackBtn.defaultProps = {
  backBtnProps: {
    step: 0,
    t: () => {},
    prevStep: () => {},
  },
};
BackBtn.propTypes = {
  backBtnProps: PropTypes.shape({
    step: PropTypes.number,
    t: PropTypes.func,
    prevStep: PropTypes.func,
  }),
};

export const SubmitGuestBtn = ({ t, id }) => {
  const { submitForm } = useFormikContext();
  return (
    <Button
      id={id}
      text={t("next")}
      bold={true}
      size="large"
      onClick={() => {
        submitForm();
      }}
    />
  );
};
SubmitGuestBtn.defaultProps = {
  id: "",
};
SubmitGuestBtn.propTypes = {
  id: PropTypes.string,
  t: PropTypes.func,
};
